import styled from 'styled-components';

export const Button = styled.div`
  background: ${({ $background }) => $background};
  border-radius: 50px;
  cursor: pointer;
  height: 56px;
  margin-right: 16px;
  width: 56px;
`;
Button.displayName = 'Button';
